(ns app.front.view.group.reporting.complaints
  (:require [app.domain.complaint.model :as complaint-model]
            [app.front.ui.filter-common :as filter-common]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.download-button :as rdb]
            [app.front.view.group.reporting.filters :as reporting-filters]
            [app.query.filter-util :as filter-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(defn optional-fields []
  (cond-> [:reporting/complaint-description-of-location
           :reporting/complaint-severity]
    (ff/enabled? :feature-flag.id/property-db-units)
    (conj :reporting/application-unit-type-and-number)))


(def default-settings
  {:categories         #{}
   :date-selector-mode #{:reporting.date-range-options/current-month}
   :review-configs     #{}})

(rf/reg-event-fx ::select-saved-filter
  (fn [{:keys [db]} [_ selected-filter]]
    (let [filter-values      (filter-util/filter-entity->search-values-map selected-filter)
          date-selector-mode (->> filter-values :date-selector-mode first)]
      {:fx [[:dispatch [::reporting-common/set-selected-categories (:categories filter-values)]]
            [:dispatch [::reporting-common/set-selected-states (:states filter-values)]]
            [:dispatch [::reporting-common/set-category-missing-selected (first (:include-category-missing filter-values))]]]
       :db (-> db
               (p/assoc-if ::reporting-common/date-selector-mode date-selector-mode))})))

(rf/reg-event-db ::initialize-settings
  (fn [db _]
    (let [{:keys [categories states date-selector-mode]} default-settings]
      (-> db
          (assoc ::reporting-common/selected-states states)
          (assoc ::reporting-common/date-selector-mode (first date-selector-mode)
                 ::reporting-common/selected-categories categories
                 ::reporting-common/category-missing-selected? false)))))

(rf/reg-sub ::filter-settings
  :<- [::gas/group]
  :<- [::reporting-common/selected-categories]
  :<- [::reporting-common/date-selector-mode]
  :<- [::reporting-common/selected-states]
  :<- [::reporting-common/category-missing-selected?]
  (fn [[group
        categories
        date-selector-mode
        states
        category-missing-selected?] _]
    (merge (util/mmap {:date-selector-mode #{date-selector-mode}
                       :group-id           #{(:db/id group)}}
                      categories
                      states)
           (when category-missing-selected?
             {:include-category-missing #{category-missing-selected?}}))))

(rf/reg-sub ::filters-in-default-state?
  :<- [::filter-settings]
  (fn [filter-settings]
    (= (dissoc filter-settings :group-id) default-settings)))

(rf/reg-sub ::conditions
  :<- [::gas/group-id]
  :<- [::filter-settings]
  (fn [[group-id filter-settings]]
    (-> filter-settings
        (assoc :group-id #{group-id})
        filter-common/filter-values->conditions)))

(rf/reg-sub ::query
  :<- [::gas/group-id]
  :<- [::reporting-common/selected-categories]
  :<- [::reporting-common/category-missing-selected?]
  :<- [::reporting-common/selected-states]
  :<- [::reporting-common/date-range]
  :<- [::reporting-common/selected-optional-fields]
  (fn [[group-id categories category-missing-selected? states
        [start-date end-date] optional-fields] _]
    (-> {:group-id group-id}
        (p/assoc-if :categories (seq categories)
                    :include-category-missing category-missing-selected?
                    :states (seq states)
                    :start-date start-date
                    :end-date end-date
                    :optional-fields optional-fields))))

(defn view [match]
  (let [tr          (<sub [::gas/group-tr])
        query       (<sub [::query])
        auth-group? (<sub [::gas/auth-group?])]
    [reporting-common/report-page
     match
     tr
     [:section
      [reporting-filters/filters tr {:filter-type             :filter.type/reporting.complaints
                                     :filter-settings-sub     ::filter-settings
                                     :default-filters-sub     ::filters-in-default-state?
                                     :conditions-sub          ::conditions
                                     :select-saved-filter-evt ::select-saved-filter
                                     :initialize-settings-evt ::initialize-settings}]]

     [:section
      [:h3.m-0 (tr [:reporting/time-range])]

      [:div.w-full
       [reporting-common/date-range-selector tr "complaint-date-range" reporting-common/date-range-options]]]

     [:section
      (when auth-group?
        [:div.w-full.mb-6
         [reporting-common/category-selector tr true]])
      [:div.w-full.mb-8
       [reporting-common/status-selector {:tr tr :states complaint-model/complaint-states :header-key :reporting.complaints/status}]]
      [:div.w-full.mb-8
       [reporting-common/optional-field-selector tr :complaints (optional-fields)]]]

     [:div.w-full.mb-8
      [rdb/download-button
       (util/mmap {:base-url "/api/command/report/download-complaint-report"}
                  tr query)]]]))

(def route
  {:name        :view/group.reporting.complaints
   :view        view
   :breadcrumb  {:items [:view/group.reporting.complaints]}
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::reporting-filters/fetch-saved-filters group-id])
                                  (>evt [::reporting-common/init group-id (first reporting-common/date-range-options)])))
                  :stop       (fn []
                                (>evt [::initialize-settings]))}]})
